import { RootState } from "@/store/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** State specific for the mini map */
type MiniMapState = {
  /** Whether the minimap is in waypoint editing mode */
  isEditing: boolean;
};

const initialState: MiniMapState = {
  isEditing: false,
};

const miniMapSlice = createSlice({
  initialState,
  name: "minimap",
  reducers: {
    setMiniMapIsEditing(state, action: PayloadAction<boolean>) {
      state.isEditing = action.payload;
    },
  },
});

export const { setMiniMapIsEditing } = miniMapSlice.actions;

export const miniMapReducer = miniMapSlice.reducer;

/**
 * @returns Whether the minimap is in waypoint editing mode
 * @param state RootState
 */
export function selectIsMinimapEditing(state: RootState): boolean {
  return state.miniMap.isEditing;
}
